import * as $ from 'jquery';
window['jQuery'] = window['$'] = $;

$(function () {
  $('.hamburger').click(function () {
    $('.main-menu-box').toggleClass('open');
  });

  $('.faq .qu').click(function () {
    let $this = $(this).parent();
    if ($this.hasClass('open')) {
      $this.children('.an-box').removeAttr('style');
      $this.removeClass('open');
    } else {
      $('.faq.open .an-box').removeAttr('style');
      $('.faq.open').removeClass('open');
      $this.children('.an-box').css('height', $this.find('.an').innerHeight());
      $this.addClass('open');
    }
  });

  $('.filter-link').click(function (event) {
    event.preventDefault();
    $('.download').hide();
    let cat = $(this).attr('data-cat');
    $('.download.' + cat).show();
  });

  $('.show-all').click(function (event) {
    event.preventDefault();
    $('.download').removeAttr('style');
  });
});
